export const environment = {
  apiUrl: 'https://dev-oc-touchpoint-backend.azurewebsites.net/api/',
  authUrl: 'https://dev-ocauth.azurewebsites.net/',
  authApi: 'https://dev-auth.offercraft.net/',
  kioskApi: 'https://dev-oc-touchpoint-kiosk-api.azurewebsites.net/',
  previewUrl: 'https://dev-kiosk.offercraft.net/'
};
